module.exports = __webpack_public_path__ + "img/red-flag.63b3e844.svg";